import './HeroSectionBox.css'
import '../pages/Home.css'

import { FaLocationDot } from "react-icons/fa6";
import hero from "../assets/image/hero1.jpg";

function HeroSectionBox() {
    return (
        <>
            <div className="HeroSectionBox">
                <div className="container-fluid-hero-section-crp">
                        <div className="hero-img-section">
                            <div className="hero-img">
                                <img src={hero} alt="" />
                                <div className="hero-text-overlay">
                                    <div className="hero-text">
                                        <h3>Revive Your Team Spirit – One Recreation Day at a Time</h3>
                                        <p>Tailored corporate recreation programs that engage, energize, and retain your teams.</p>
                                        <button className='hero-btn'>Get Free Quote</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                </div>
            </div>
        </>
    )
}

export default HeroSectionBox
